import { DoubleUnderline } from "./double-underline";

export * from "./double-underline";

export default DoubleUnderline;